module.exports = __webpack_public_path__ + "static/faq-one-1-ac5f8a541dff34256b31531f161c580f.png";